// The hero's working phone: a guided session reduced to what a visitor can try (finish a set, rest, the next set),
// as pure state so it can be tested. Loads are in the site's unit and move in the equipment's own steps.
import { loadStep } from '../../utils/guidedSession';

/** Treino A, three sets into its first exercise: set 3 of the bench press is up */
export const startSession = (workout, unit) => ({
  ex: 0,
  set: 2,
  view: 'set',
  reps: workout[0].reps,
  load: workout[0].load[unit],
  left: 0,
  total: 0,
});

/** The set after this one: the next of the same exercise, or the first of the next (the last wraps to the first) */
export const nextSet = (state, workout) => {
  const exercise = workout[state.ex];
  if (state.set + 1 < exercise.sets) return { ex: state.ex, set: state.set + 1, exercise };
  const ex = (state.ex + 1) % workout.length;
  return { ex, set: 0, exercise: workout[ex] };
};

/** Sets done so far, as the session's top line counts them ("3 de 19 séries") */
export const setsDone = (state, workout) =>
  workout.slice(0, state.ex).reduce((total, exercise) => total + exercise.sets, 0) + state.set + (state.view === 'rest' ? 1 : 0);

export const totalSets = (workout) => workout.reduce((total, exercise) => total + exercise.sets, 0);

// The rest is over: the next set comes up, with the exercise's own reps and load when it's a new one
const advance = (state, workout, unit) => {
  const next = nextSet(state, workout);
  const isSame = next.ex === state.ex;
  return {
    ...state,
    view: 'set',
    ex: next.ex,
    set: next.set,
    reps: isSame ? state.reps : next.exercise.reps,
    load: isSame ? state.load : next.exercise.load[unit],
    left: 0,
    total: 0,
  };
};

const round = (value) => Math.round(value * 100) / 100;

/**
 * One step of the session. Actions: done (the set is finished, the rest starts), tick (a second of rest),
 * shift (± seconds of rest; at zero the rest ends), skip (end the rest now), reps and load (± one step).
 */
export const sessionStep = (state, action, workout, unit) => {
  const exercise = workout[state.ex];
  switch (action.type) {
    case 'done':
      return state.view === 'set' ? { ...state, view: 'rest', left: exercise.rest, total: exercise.rest } : state;
    case 'tick':
      if (state.view !== 'rest') return state;
      return state.left <= 1 ? advance(state, workout, unit) : { ...state, left: state.left - 1 };
    case 'shift': {
      if (state.view !== 'rest') return state;
      const left = Math.max(0, state.left + action.seconds);
      return left === 0 ? advance(state, workout, unit) : { ...state, left, total: Math.max(state.total, left) };
    }
    case 'skip':
      return state.view === 'rest' ? advance(state, workout, unit) : state;
    case 'reps':
      return { ...state, reps: Math.max(1, state.reps + action.delta) };
    case 'load':
      return { ...state, load: Math.max(0, round(state.load + action.delta * loadStep(exercise.equipment, exercise.en, unit))) };
    default:
      return state;
  }
};
